import axios from 'axios'
import serverUrl from '@/assets/BaseServerUrl.js'

const base = `${serverUrl}/api/follows`

export default {
  async getList(userId, type, page = 1, pageSize = 20) {
    let params = { userId }
    if (type) {
      params.type = type
      params.page = page
      params.pageSize = pageSize
    }
    const res = await axios.get(`${base}/list`, { params })
    return res.data
  },
  async getState(userId) {
    const res = await axios.get(`${base}/state`, { params: { userId } })
    return res.data
  },
  async follow(followerId, followingId) {
    const res = await axios.post(`${base}/add`, { followerId, followingId })
    return res.data
  },
  async unfollow(followerId, followingId) {
    const res = await axios.delete(`${base}/remove`, { data: { followerId, followingId } })
    return res.data
  },
  async setRemark(userId, targetUserId, remark) {
    const res = await axios.post(`${base}/remark`, { userId, friendUserId: targetUserId, remark })
    return res.data
  }
}
